// App roles assigned in Entra ID, read from the access token's `roles` claim
export const ROLES = {
  techSupport: 'pg-tech-support',
  marketingDashboard: 'pg-marketing-dashboard',
} as const

export const DASHBOARD_ROLES: string[] = [ROLES.techSupport, ROLES.marketingDashboard]

// No required roles means the item is open to every signed-in user
export const hasAnyRole = (userRoles: string[], requiredRoles?: string[]): boolean =>
  !requiredRoles?.length || requiredRoles.some(role => userRoles.includes(role))
